import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'react-final-form';
import {Grid, TextInput} from '@tenancy.nz/design-system';
import {getFieldProps, isRequired} from '../utils/helpers';

function AddressFieldset({name, ...rest}) {
  const prefix = name ? `${name}.` : ``;
  return (
    <Grid container spacing={5} {...rest}>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}street`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Street"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}suburb`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Suburb"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}city`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="City"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Field name={`${prefix}country`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Country"
            />
          )}
        </Field>
      </Grid>
      <Grid item xs={12} sm={3} md={2}>
        <Field name={`${prefix}postcode`} validate={isRequired}>
          {({input, meta}) => (
            <TextInput
              {...getFieldProps({input, meta})}
              required
              fullWidth
              label="Zip/Postal"
            />
          )}
        </Field>
      </Grid>
    </Grid>
  );
}

AddressFieldset.propTypes = {
  /**
   *
   */
  name: PropTypes.string,
};

AddressFieldset.defaultProps = {
  name: undefined,
};

export default AddressFieldset;
